import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    $(this.element).selectpicker({
        noneSelectedText: 'Selecione se houver'
    })
  }

  teardown() {
    $(this.element).selectpicker('destroy')
  }
}
